import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {i18n} from '@/plugin/i18n';

// gestion des touch events
import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

// gestion des evenement et ecouteurs
import VueEvents from 'vue-events';
Vue.use(VueEvents);

// gestion des fontawesome, on le declare de manière globale pour les utiliser de partout
// https://github.com/FortAwesome/vue-fontawesome#recommended
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faChevronDown, faArrowDown, faChartLine, faChevronLeft, faChevronRight, faClock, faCheck} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faUserSecret, faChevronDown, faArrowDown, faChartLine, faChevronLeft, faChevronRight, faClock, faCheck);
Vue.component('font-awesome-icon', FontAwesomeIcon);


// gestion des métas
import Meta from 'vue-meta';
Vue.use(Meta);


Vue.config.productionTip = false;


new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    mounted: function() {
        setTimeout(() => {
            document.dispatchEvent(new Event('x-app-rendered'));
        }, 2000);
    }
});
